module.exports = __webpack_public_path__ + "static/media/freshgrocer-onboarding-card.ca8b4208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshgrocer-onboarding-card.png
// module id = 365
// module chunks = 0